/* __next_internal_client_entry_do_not_use__ PAGE_LINK_SIZE,PAGE_LINK_MARGIN,DESKTOP_NEXT_LINK_HEIGHT,DESKTOP_NEXT_LINK_MIN_WIDTH,DESKTOP_NEXT_LINK_MARGIN,NEXT_LINK_SIZE,NEXT_LINK_MARGIN,MOBILE_NEXT_LINK_MARGIN,FooterWrapper,Wrapper,DesktopWrapper,MobileWrapper,DesktopButton,MobileButton,PageWrapper,TextPageLink,IconPageLink,NavigationButton auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import classNames from "classnames";
import * as React from "react";
import styled, { css, useTheme } from "styled-components";
import { Link } from "../../ui/LinkAnchor";
import { IconButton } from "../IconButton";
import { responsiveMediaQueries } from "../Theme/responsiveMediaQueries";
import { HIGH_VIS_FILTER, highVisSlateComponent } from "../utils/highVisSlateComponent";
export var PAGE_LINK_SIZE = 32;
export var PAGE_LINK_MARGIN = 8;
export var DESKTOP_NEXT_LINK_HEIGHT = 24;
export var DESKTOP_NEXT_LINK_MIN_WIDTH = 100;
var DESKTOP_NEXT_LINK_MAX_WIDTH = 144;
export var DESKTOP_NEXT_LINK_MARGIN = 32;
export var NEXT_LINK_SIZE = 48;
var XXS_NEXT_LINK_SIZE = 32;
export var NEXT_LINK_MARGIN = 32;
export var MOBILE_NEXT_LINK_MARGIN = 16;
/* When the screensize is less than 390px, removing the margin for navigation buttons to fit the screen. */ var XS_SCREEN_WIDTH = 390;
/* When the screensize is less than 344px, removing the margin for navigation buttons is not enough,
 * The button width will also be reduced to 32px.
 */ var XXS_SCREEN_WIDTH = 344;
export var FooterWrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-ed2e71b-0"
})([
    "width:100%;"
]);
export var Wrapper = styled(Row).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-ed2e71b-1"
})([
    "width:100%;flex-shrink:0;",
    ""
], highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
export var DesktopWrapper = styled(Wrapper).withConfig({
    componentId: "sc-ed2e71b-2"
})([
    "&&&{",
    "{display:none;}}"
], responsiveMediaQueries.mobile);
export var MobileWrapper = styled(Wrapper).withConfig({
    componentId: "sc-ed2e71b-3"
})([
    "&&&{",
    "{display:none;}}"
], responsiveMediaQueries.tabletAndAbove);
export var DesktopButton = styled(Button).withConfig({
    componentId: "sc-ed2e71b-4"
})([
    "max-width:",
    "px;min-width:",
    "px;width:100%;height:",
    "px;line-height:18px;margin:0 ",
    "px;"
], DESKTOP_NEXT_LINK_MAX_WIDTH, DESKTOP_NEXT_LINK_MIN_WIDTH, DESKTOP_NEXT_LINK_HEIGHT, DESKTOP_NEXT_LINK_MARGIN);
export var MobileButton = styled(Button).withConfig({
    componentId: "sc-ed2e71b-5"
})([
    "width:100%;height:",
    "px;"
], PAGE_LINK_SIZE);
export var PageWrapper = styled(Row).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-ed2e71b-6"
})([
    ""
]);
export var TextPageLink = function(props) {
    var active = props.active, className = props.className, otherProps = _object_without_properties(props, [
        "active",
        "className"
    ]);
    var pagination = useTheme().pagination;
    var pageColors = active ? pagination.activePage : pagination.inactivePage;
    var text = pagination.text;
    return /*#__PURE__*/ _jsx(CircleLink, _object_spread_props(_object_spread({}, otherProps), {
        className: classNames(className, active ? "active" : "inactive"),
        colors: pageColors,
        text: text,
        width: PAGE_LINK_SIZE,
        margin: PAGE_LINK_MARGIN
    }));
};
export var IconPageLink = function(props) {
    var active = props.active, className = props.className, otherProps = _object_without_properties(props, [
        "active",
        "className"
    ]);
    var pagination = useTheme().pagination;
    var pageColors = active ? pagination.activePage : pagination.inactivePage;
    var text = pagination.text;
    return /*#__PURE__*/ _jsx(IconButtonCircleLink, _object_spread_props(_object_spread({}, otherProps), {
        className: classNames(className, active ? "active" : "inactive"),
        colors: pageColors,
        text: text,
        width: PAGE_LINK_SIZE,
        margin: PAGE_LINK_MARGIN,
        tabIndex: otherProps.disabled ? -1 : 0
    }));
};
var CircleLink = styled(Link).withConfig({
    componentId: "sc-ed2e71b-7"
})([
    "",
    ""
], function(param) {
    var colors = param.colors, text = param.text, width = param.width, margin = param.margin, disabled = param.disabled;
    return css([
        "min-width:",
        "px;padding:6px;height:",
        "px;margin:0 ",
        "px !important;",
        " display:flex;align-items:center;justify-content:center;border-radius:100px;background-color:",
        ";&,&:focus,&:active{color:",
        ";}&:hover{background-color:",
        ";}",
        ";"
    ], width, width, margin, TypographyStyles(text), colors.color, colors.contrast, colors.hover, disabled ? "pointer-events: none; cursor: none" : "");
});
var IconButtonCircleLink = styled(CircleLink).withConfig({
    componentId: "sc-ed2e71b-8"
})([
    "&:hover{border:1px solid ",
    ";}&:focus-visible{outline:1px solid -webkit-focus-ring-color;}"
], Core.border.default);
export var NavigationButton = styled(IconButton).attrs({
    shape: "square"
}).withConfig({
    componentId: "sc-ed2e71b-9"
})([
    "width:",
    "px;height:",
    "px;margin:0 ",
    "px;@media (max-width:767px){margin:0 ",
    "px;}@media (max-width:",
    "px){margin:0;}@media (max-width:",
    "px){width:",
    "px;height:",
    "px;}"
], NEXT_LINK_SIZE, NEXT_LINK_SIZE, NEXT_LINK_MARGIN, MOBILE_NEXT_LINK_MARGIN, XS_SCREEN_WIDTH, XXS_SCREEN_WIDTH, XXS_NEXT_LINK_SIZE, XXS_NEXT_LINK_SIZE);
